<template>
  <Modal
    class="scoped"
    :hide-close-button="!completed"
    :persistent="!completed"
    title="Bulk Action Alert"
  >
    <div>
      <template v-if="!!error && actionUserId === currentUser.id">
        <div class="row q-pa-md">
          <QIcon
            color="negative"
            name="error"
            size="20px"
          />
          <span class="q-ml-md bold">
            An error occurred while performing the bulk {{ action }} action
          </span>
        </div>
        <div class="row pull-right">
          <BaseButton
            class="q-ma-md"
            color="primary"
            label="Okay"
            @click="emits('close')"
          />
        </div>
      </template>
      <template v-else-if="!completed">
        <div class="row q-pa-md bold">
          A bulk {{ action }} action is being performed by {{ actionUserName }}.
        </div>
        <div class="row q-pa-md bold">Please wait for it to complete..</div>
        <div class="row q-pa-md">
          <QLinearProgress
            class="q-mt-sm"
            color="online"
            rounded
            size="10px"
            stripe
            :value="progress"
          />
        </div>
      </template>
      <template v-else>
        <div class="row q-pa-md bold">
          A bulk {{ action }} action has been performed by {{ actionUserName }}.
        </div>
        <div class="row q-pa-md bold">
          The bulk {{ action }} action has been completed
        </div>
        <div class="row pull-right">
          <BaseButton
            class="q-ma-md"
            color="primary"
            label="Okay"
            @click="emits('close')"
          />
        </div>
      </template>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";

import BaseButton from "shared/components/base/BaseButton.vue";
import Modal from "shared/components/core/modals/Modal.vue";

import { useInsightsStore } from "src/stores/insights";
import { useUserStore } from "src/stores/user";

const userStore = useUserStore();
const { currentUser } = storeToRefs(userStore);

const insightsStore = useInsightsStore();
const { querySubscriptionData } = storeToRefs(insightsStore);

const emits = defineEmits<{
  close: [];
}>();

const progress = computed(() => {
  if (querySubscriptionData.value) {
    return processed.value / total.value;
  }

  return 0;
});

const processed = computed(() => {
  if (querySubscriptionData.value) {
    return querySubscriptionData.value.processed;
  }

  return 0;
});

const total = computed(() => {
  if (querySubscriptionData.value) {
    return querySubscriptionData.value.total;
  }

  return 1;
});

const action = computed(() => {
  if (querySubscriptionData.value) {
    return querySubscriptionData.value.action;
  }

  return "";
});

const actionUserName = computed(() => {
  if (querySubscriptionData.value) {
    return querySubscriptionData.value.user?.name;
  }

  return "";
});

const actionUserId = computed(() => {
  if (querySubscriptionData.value) {
    return querySubscriptionData.value.user?.id;
  }

  return 0;
});

const completed = computed(() => {
  if (
    querySubscriptionData.value &&
    querySubscriptionData.value.completed !== undefined
  ) {
    return querySubscriptionData.value.completed;
  }

  return true;
});

const error = computed(() => {
  if (querySubscriptionData.value) {
    return querySubscriptionData.value.error;
  }

  return false;
});
</script>
